"use strict";

const Extras = () => {
    const init = () => {
        $(document).ready(function () {


        });
    };

    return {
        init: init
    };
};

export default Extras;